<template>
  <div class="ad-wecom-popup">
    <div
      v-if="show"
      class="mask"
    />
    <div
      v-if="show"
      class="ad-wecom-popup ad-wecom-popup-middle"
    >
      <div class="ad-wecom-popup-content">
        <img
          src="@/assets/img/chargingVoucher/ad-wecom-popup-close-btn.png"
          class="ad-wecom-popup-content-close-btn"
          @click="() => closePopup(1)"
        >
        <img
          src="@/assets/img/chargingVoucher/ad-wecom-popup-bg.png"
          class="ad-wecom-popup-content-bg"
        >
        <img
          src="@/assets/img/chargingVoucher/ad-wecom-popup-confirm-btn.png"
          class="ad-wecom-popup-content-confirm-btn"
          @click="toWecomPage"
        >
      </div>
      <div
        class="ad-wecom-popup-bottom-text mt60"
        @click="() => closePopup(7)"
      >
        近期不再显示
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdWecomPopup',
  data() {
    return {
      show: false
    };
  },
  methods: {
    openPopup() {
      this.show = true;
      this.$emit('open');
    },
    closePopup(day) {
      this.show = false;
      this.$emit('close', { day });
    },
    // 跳转企业微信页
    toWecomPage() {
      this.closePopup(7);
      wx.miniProgram.navigateTo({
        url: '/pages/extend/salesman-wecom'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.ad-wecom-popup {
  .mask {
    position: fixed;
    z-index: 9999;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .ad-wecom-popup {
    position: fixed;
    z-index: 9999;
  }

  .ad-wecom-popup-middle {
    display: flex;
    flex-direction: column;
    align-items: center;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    & > img {
      object-fit: contain;
    }
    .ad-wecom-popup-content {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;

      .ad-wecom-popup-content-close-btn {
        width: 48px;
        height: 48px;
        position: absolute;
        top: 16px;
        right: 32px;
      }
      .ad-wecom-popup-content-bg {
        width: 630px;
        height: 790px;
      }
      .ad-wecom-popup-content-confirm-btn {
        width: 380px;
        height: 120px;
        position: absolute;
        bottom: 33px;
      }
    }
    .ad-wecom-popup-bottom-text {
      font-family: PingFangSC-Regular;
      font-size: 32px;
      color: #e6e6e6;
      text-align: center;
      font-weight: 400;
      line-height: 45px;
    }
  }
}
</style>
